exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".r-user-settings-top-section {\r\n  padding-left: 20px;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/pages/user-settings/styles.css
// module id = 2743
// module chunks = 29